export enum SnackbarType {
    Success = 1,
    Error,
    Info
}
